import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  deletePlantMaster,
  listPlantMasters,
} from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * 発電所マスタ削除 mutation hook。
 * onSuccess で list query を invalidate してテーブルを最新化する。
 * optimistic locking: expected_updated_at を request に含める。
 */
export function useDeletePlantMaster(): InvalidatingMutationResultFor<
  typeof deletePlantMaster
> {
  return useInvalidatingMutation(deletePlantMaster, [
    createConnectQueryKey({ schema: listPlantMasters, cardinality: 'finite' }),
  ])
}
